/**
 * Lechia Product
 */
 let LechiaProduct = {

    /**
     * Product's first option types
     */
    FIRST_OPTION_TYPES : {
        QUANTITY : 'quantity',
        SINGLE_PRODUCT : 'single_product',
        SINGLE_VARIANT : 'single_variant'
    },

    /**
     * Get total amount of visible variants from a product
     * @param {*} variant 
     * @returns {String}
     */
    getVariantCount(product) {
        let variantCount = 0;
        _.each(product.variants, (variant) => {
            if (!LechiaVariant.isHidden(variant)) {
                variantCount++;
            }
        });
        return variantCount;
    },

    /**
     * Get the first option type
     * @param {*} product 
     * @returns {String}
     */
    getFirstOptionType(product) {
        if (!_.isEmpty(product.options[0])) {
            return LechiaHelper.slugify(product.options[0]);
        }
        return '';
    },

    /**
     * Get the second option type
     * @param {*} product 
     * @returns {String}
     */
    getSecondOptionType(product) {
        if (!_.isEmpty(product.options[1])) {
            return LechiaHelper.slugify(product.options[1]);
        }
        return '';
    },

    /**
     * Get variants availability
     * @param {*} variants
     * @returns {Boolean}
     */
     getVariantsAvailability(variants) {
        var availability = false;
        _.each(variants, function(variant) {
          if (variant.available) {
            availability = true;
          }
        });
        return availability;
    },

};